import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { t, getVatPriceProps } from '@insight/toolkit-utils';
import { Currency, Field, ListPrice } from '../../index';
import BetterTogetherItem from './BetterTogetherItem';

export const BetterTogetherNewListItem = ({
  materialId,
  description,
  clickTrackingURL,
  price,
  image,
  isCurrentItem,
  isSelected,
  isDisabled,
  onSelect,
  isLoggedIn,
  showVAT,
  setMiniPDP,
  webGroupPermissions,
  newWebPriceFeature,
  showPrice,
}) => {
  // For pricing, please check the developer note on getPlacements function
  const {
    listPrice,
    price: insightPrice,
    priceInclVat,
    currency,
  } = price || {};
  const { enableListPrice, disableStockAndPrice: isStockAndPriceDisabled } =
    webGroupPermissions;

  const renderPricing = () => {
    if (!insightPrice || isStockAndPriceDisabled) return null;
    const { exclVatProps, inclVatProps } = getVatPriceProps(showVAT);
    const displayVatPrice = showVAT && priceInclVat;
    return (
      <div className="o-grid__item c-product-better-together__item-prices">
        <div className="c-product-better-together__item-strike-price">
          {(newWebPriceFeature || isLoggedIn) && enableListPrice && (
            <ListPrice
              currencyCode={currency}
              listPrice={listPrice}
              insightPrice={insightPrice}
              strike
              {...exclVatProps}
            />
          )}
        </div>
        <div>
          <Currency
            currencyCode={currency}
            value={newWebPriceFeature || isLoggedIn ? insightPrice : listPrice}
            className={cn({ 'c-currency__ex-vat': showVAT })}
            {...exclVatProps}
          />
        </div>
        {displayVatPrice && (
          <div>
            <Currency
              currencyCode={currency}
              value={priceInclVat}
              {...inclVatProps}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="c-product-better-together__item o-grid__item u-1/2 u-1/6@tablet-landscape">
      <div
        className={cn('c-product-better-together__item-container', {
          selected: isSelected,
        })}
      >
        <BetterTogetherItem
          isCurrentItem={isCurrentItem}
          materialId={materialId}
          src={image}
          alt={description}
          description={description}
          clickTrackingURL={clickTrackingURL}
          setMiniPDP={setMiniPDP}
        />
        <div
          className={cn(
            `o-grid c-product-better-together__item-bottom 
          ${isStockAndPriceDisabled ? 'o-grid--justify-right' : 'o-grid--justify-between'}`,
            {
              'c-product-better-together__item-bottom__vat': showVAT,
            }
          )}
        >
          {showPrice && renderPricing()}
          {showPrice && (
            <div
              className={cn(
                'o-grid__item o-grid__item--shrink c-better-together__checkbox-container',
                {
                  'c-better-together-view': isStockAndPriceDisabled,
                }
              )}
            >
              <Field
                onChange={onSelect}
                fieldComponent="Checkbox"
                name="betterTogether"
                checked={isSelected}
                custom
                disabled={isDisabled}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BetterTogetherNewListItem.propTypes = {
  materialId: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  clickTrackingURL: PropTypes.string,
  price: PropTypes.shape({
    price: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    listPrice: PropTypes.string,
    insightPrice: PropTypes.string,
  }),
  image: PropTypes.string.isRequired,
  isCurrentItem: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  showPrice: PropTypes.bool,
};

BetterTogetherNewListItem.defaultProps = {
  showPrice: true,
};
